<template>
    <div v-if="loaded">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="moduleIn.las_groups">
            <template v-slot:options>
                <b-button
                    class="btn-module-access-add-las"
                    v-b-modal="'module-access-add-las-groups'"
                    variant="primary">
                    <i class="fas fa-plus fa-fw"></i> {{ $t('modules.add_group') }}
                </b-button>

                <design-2021-module-management-edit-access-las-modal-component
                    :module-in="moduleIn"
                    :las-groups-in="lasGroups"></design-2021-module-management-edit-access-las-modal-component>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <b-button
                        class="btn-remove"
                        variant="danger-icon-only"
                        @click="deleteLasGroup(data.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import { ords } from '../../../app';

const lasGroupsOrds = ords.use('las_groups');

export default {
    name: 'design-2021-module-management-edit-access-las-component',
    props: {
        lasGroupsIn: Array,
        moduleIn: Object,
    },
    data() {
        return {
            selectedLasGroupsIds: this.moduleIn.las_groups.map((las_group) => las_group.id),
            lasGroups: null,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            loaded: false,
        };
    },
    methods: {
        deleteLasGroup(las_group) {
            this.alert
                .confirm(this.$t('modules.delete_group'), this.$t('modules.are_you_sure_you_want_to_delete_this_group'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.moduleLasGroupDelete(las_group.id, this.moduleIn.id)).then(
                            (response) => {
                                ords.use('module').detach(this.moduleIn.id, 'las_groups', las_group.id);

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
    watch: {
        moduleIn: function (value) {
            lasGroupsOrds
                .whereNotIn(
                    'id',
                    value.las_groups.map((las_group) => las_group.id),
                )
                .get()
                .subscribe((las_groups) => {
                    this.lasGroups = las_groups;
                });
        },
    },
    mounted() {
        if (!this.loaded) {
            lasGroupsOrds.add(this.lasGroupsIn);

            lasGroupsOrds
                .whereNotIn(
                    'id',
                    this.moduleIn.las_groups.map((las_group) => las_group.id),
                )
                .get()
                .subscribe((las_groups) => {
                    this.lasGroups = las_groups;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;

    .btn:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}
</style>
